import type { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

import { BaseMedia } from './BaseMedia';

type ImageFileInfo = {
    width: number;
    height: number;
    size: number;
    mime_type: string;
    aspect_ratio: number;
};

export class ImageMedia extends BaseMedia {
    type: 'image';
    image: string;
    file_info: ImageFileInfo;

    constructor(attachment: DMConversationMessage['attachments'][0]) {
        super(attachment);
        this.type = 'image';
        this.image = attachment.url;
        this.file_info = {
            width: parseInt(attachment.width),
            height: parseInt(attachment.height),
            size: 0,
            mime_type: attachment.type,
            aspect_ratio: 0
        };
    }
}
